export default "__VITE_ASSET__46f04959__"